import * as React from "react";

export default function PropertyIcon(props: React.SVGProps<any>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} viewBox="0 0 15 15" {...props}>
      <g transform="translate(1 -2)" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke="currentColor" strokeWidth={1.5}>
          <path d="M2.235 15.39h8.53c.898 0 1.626-.727 1.626-1.624V7.672L6.5 3.61.61 7.672v6.094c0 .897.727 1.625 1.625 1.625z" />
          <path d="M4.672 12.546c0-.897.727-1.625 1.625-1.625h.406c.897 0 1.625.728 1.625 1.625v2.844H4.672v-2.844z" />
        </g>
      </g>
    </svg>
  );
}
